/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';

import ControlBoxForm from '../forms/control-box-form';
import EditItemDialog from '../dialogs/edit-item-dialog';

import formatLastSeenOnline from '../../utils/format-last-seen-online';

import { CardAttr } from '../widgets/card-attr';

import { DeviceStatus } from '../device-status';
import styled from 'styled-components';
import { colors } from '../../themes';
import { UnsupportedDeleteIcon } from './unsupported-delete-icon';

const Container = styled.div`
  padding: 1em;
`;
const Header = styled.section`
  display: grid;
  grid-template-columns: 1fr auto;
  span.led,
  i.server {
    margin-right: 0.5em;
  }
`;
const Actions = styled.div`
  i {
    cursor: pointer;
  }
  i.remove {
    color: ${colors.baseColors.red};
    margin-right: 0px;
  }
`;
const Content = styled.section`
  display: grid;
  grid-gap: 4px;
`;
const TicketFormat = styled.div`
  cursor: pointer;
  span.title {
    width: 50px;
    font-size: 12px;
    color: ${colors.baseColors.grey};
  }
`;
function Title(props: any) {
  return (
    <span>
      <Icon name="server" />
      <DeviceStatus connectionStatus={props.connectionStatus} title={props.uuid} />
    </span>
  );
}

export default function ControlBoxCard(props: any) {
  const [showFormats, setShowFormats] = useState(false);

  return (
    <Container>
      <Header>
        <h3>
          <Title {...props} />
        </h3>
        <Actions>
          <EditItemDialog form={ControlBoxForm} {...props} />
          <UnsupportedDeleteIcon what="control box" />
        </Actions>
      </Header>
      <Content>
        {props.connectionStatus === 'disconnected' ? (
          <CardAttr title="Last Seen Online">{formatLastSeenOnline(props.lastSeenOnline)}</CardAttr>
        ) : (
          ''
        )}
        <CardAttr title="UUID">{props.uuid}</CardAttr>
        <CardAttr title="Log Level">{props.logLevel}</CardAttr>
        <CardAttr title="Time Zone">{props.timeZone}</CardAttr>
        <CardAttr title="TemplateCode">{props.ticketFormatTemplateCode}</CardAttr>
        <TicketFormat onClick={() => setShowFormats(!showFormats)}>
          <span className="title ticket">Ticket Format</span>
          {showFormats ? <Icon name="caret down" /> : <Icon name="caret right" />}
          {showFormats && <pre>{props.ticketFormat}</pre>}
        </TicketFormat>
      </Content>
    </Container>
  );
}
